import { render, staticRenderFns } from "./SaleDetail.vue?vue&type=template&id=0f349a9d&"
import script from "./SaleDetail.vue?vue&type=script&lang=js&"
export * from "./SaleDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports